<div [formGroup]="form" [ngStyle]="getOrientation()">
  <div *ngFor="let item of items; let i = index">
    <mat-checkbox class="checkbox-item" [checked]="form.get('checkboxGroup')?.value[i]" (change)="onCheckboxChange($event, i)">
      {{ item.label }}
    </mat-checkbox>
  </div>
</div>
